import React, { useState } from 'react';

import {
  FormControl,
  Box,
  FormHelperText,
  Slider,
  Typography,
} from '@mui/material';

export default function NumDocsField({ value, setValue, ...rest }) {
  const [initialValue] = useState(value);
  const handleChange = (event, newValue) => {
    setValue(parseInt(newValue));
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <Typography>Number of Documents</Typography>
        <Slider
          {...rest}
          aria-label='Number of Documents'
          defaultValue={initialValue}
          valueLabelDisplay='auto'
          aria-describedby='num-docs-helper-text'
          onChange={handleChange}
          min={1}
          max={5}
        />

        <FormHelperText id='num-docs-helper-text'>
          The number of documents to include in the prompt as question context.
        </FormHelperText>
      </FormControl>
    </Box>
  );
}
